export default __webpack_public_path__ + "static/media/Group 1284TataNeu@2x.710ed3d8.png";